import React, { useState } from "react";
import Payment from "../Payment/Payment.js";
import "./PaymentList.css";

const PaymentList = ({
  paymentList,
  handleToggle,
  handleUpdatePayment,
  charLimit = 16, // Default charLimit to 16 if not provided
}) => {
  const [editId, setEditId] = useState(null); // Track which payment is being edited
  const [editValue, setEditValue] = useState(""); // Track the current edit value
  const [isExceedingLimit, setIsExceedingLimit] = useState(false); // Track if limit is exceeded

  const handleEditClick = (payment) => {
    setEditId(payment.id); // Set the payment to edit mode
    setEditValue(payment.paymentName); // Set the current value to the input field
    setIsExceedingLimit(false); // Reset the exceeding limit state
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length <= charLimit) {
      setEditValue(newValue); // Update the input value only if length is <= charLimit
      setIsExceedingLimit(false); // Reset the exceeding limit state
    } else {
      setIsExceedingLimit(true); // Set exceeding limit state
    }
  };

  const handleSaveEdit = (id) => {
    const trimmedValue = editValue.trim();
    // Update the payment and set to an empty string if the value is blank
    handleUpdatePayment(id, trimmedValue);
    // Exit edit mode
    setEditId(null);
    setIsExceedingLimit(false); // Reset the exceeding limit state
  };

  return (
    <div
      className="PaymentList"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {paymentList.map((payment, index) => {
        const id = payment.id || payment._id;
        return (
          <div key={id} style={{ display: "flex", alignItems: "center" }}>
            <div className="PaymentList-number bebas-neue-regular">
              {String(index + 1).padStart(2, "0")}{" "}
            </div>
            {editId === id ? (
              // If the payment is being edited, show an input field
              <input
                id={`payment-edit-${id}`}
                className="PaymentList-item-editable"
                value={editValue}
                onChange={handleInputChange} // Use the new input change handler
                onBlur={() => handleSaveEdit(id)} // Save when input loses focus
                autoFocus // Automatically focus on the input when editing
                style={{
                  color: isExceedingLimit ? "red" : "",
                }}
              />
            ) : (
              <div
                className="PaymentList-item"
                style={{ fontWeight: "bold", fontSize: "20px" }}
                onClick={() => handleEditClick(payment)} // Enable edit mode
              >
                <Payment
                  payment={payment}
                  handleToggle={() => handleToggle(id)}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PaymentList;
